<div class="acr-auth-container">
    <div class="acr-auth-content">
        <form method="post">
            <div class="auth-text">
                <h3>Inicia sesión en Mestors</h3>
                <p>Encuentra tu proximo hogar a un click</p>
            </div>
            <div class="form-group">
                <label>Nombre de Usuario</label>
                <input type="text" class="form-control form-control-light" placeholder="Nombre de Usuario" name="username" [(ngModel)]="user"
                    value="">
            </div>
            <div class="form-group">
                <label>Contraseña</label>
                <input type="password" class="form-control form-control-light" placeholder="Contraseña" name="password" [(ngModel)]="password"
                    value="">
            </div>
            <div class="form-group">
                <a href="#" class="forgot-password">No recuerdas tú contraseña?</a>
            </div>
            <button class="btn-custom secondary btn-block" (click) =  "logIn()">Inicia Sesión</button>
            <div class="auth-seperator">
                <span>Si lo prefieres</span>
            </div>
            <div class="social-login">
                <button type="button" class="acr-social-login facebook"><i class="fab fa-facebook-f"></i> Continua con
                    Facebook </button>
                <button type="button" class="acr-social-login google" (click)="googleAuth()"><i class="fab fa-google"></i> Continua con
                    Google</button>
            </div>
            <p class="text-center mb-0">No tienes cuenta? <a routerLink="/register">Crear Cuenta</a> </p>
        </form>
    </div>
    <div class="acr-auth-bg">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="settings"
            class="acr-auth-bg-slider acr-cs-bg-slider">
            <div ngxSlickItem class="acr-auth-bg-item bg-cover bg-center" style="background-image: url('{{item.img}}')"
                *ngFor="let item of images">
                <div class="acr-auth-quote">
                    <h6>{{item.title}}</h6>
                    <p>{{item.text}}</p>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>